import { render, staticRenderFns } from "./ModalDocumentPackage.vue?vue&type=template&id=073bb8c6&"
import script from "./ModalDocumentPackage.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073bb8c6')) {
      api.createRecord('073bb8c6', component.options)
    } else {
      api.reload('073bb8c6', component.options)
    }
    module.hot.accept("./ModalDocumentPackage.vue?vue&type=template&id=073bb8c6&", function () {
      api.rerender('073bb8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/components/ModalDocumentPackage.vue"
export default component.exports